let content = [
    {
      id: "general_trading_conditions",
      title: "Allgemeine Handelsbedingungen",
      tabs: [
        {
          //id: "product_details",
          id:"tc-view-6",
          title: "Produktdetails",
          content_before: `<p class="mb-5">
                          iFOREX Europe bietet äußerst wettbewerbsfähige Konditionen für die folgenden Finanzinstrumente ("Finanzinstrumente" oder "Instrumente") (i) gehebelten Margin-Handel mit Finanzinstrumenten/zugrundeliegenden Vermögenswerten ("Zugrundeliegende Vermögenswerte"), einschließlich Währungspaaren (Forex), Rohstoffen, Indizes, Aktien, ETFs und Kryptowährungen auf Basis von CFDs ("gehebelte Instrumente" oder "CFDs").
                          <br><br>
                          <b>Speads</b><br>Die Kosten zum Eröffnen eines Geschäftes werden die Handelsspanne (Spread) genannt. Dies ist die Differenz zwischen dem Verkaufspreis (Geld) und Kaufpreis (Brief). Beispielsweise wenn der USD/JPY mit einem Verkaufspreis von 101.202 und einem Kaufpreis von 101.222 gehandelt wird, ist die Differenz zwischen den zwei Preisen die Handelsspanne. In diesem Fall ist die Handelsspanne 2 Pips. Sollten Sie sich entscheiden das Geschäft sofort nach Eröffnung zu schließen, bevor es zu Preisbewegungen kommt, wird der Betrag der Handelsspanne von Ihrem Kontostand abgezogen.
                          <br><br>
                          <b>Margin und Hebel (Leverage)</b><br>Die „Margin“ fungiert als Sicherheit, um eventuelle Verluste abzudecken, und ermöglicht es Ihnen außerdem, eine Position zu halten, die viel größer ist als Ihr tatsächlicher Kontowert. Dadurch haben Sie die Möglichkeit, im Verhältnis zum investierten Betrag, große Gewinne zu generieren.
                          <br><br>
                          Der Hebel ist ein zweischneidiges Schwert – er kann Ihre Gewinne drastisch erhöhen, er kann aber ebenso mühelos Ihre Verluste vergrößern. Wenn Sie einen übermäßig hohen Hebel verwenden, können verlustbringende Geschäfte sehr schnell viele Ihrer gewinnbringenden Geschäfte ausgleichen. Das gehebelte Handeln ist mit einem hohen Risiko verbunden und ist möglicherweise nicht für alle Investoren geeignet.
                          <br><br>
                          Als Inhaber eines iFOREX Europe-Kontos werden Sie von unserem ‘Negative Balance´ Schutzprogramms geschützt, was bedeutet, dass Sie nie mehr verlieren können als das, was Sie eingezahlt haben. Dennoch kann eine kleine Bewegung am Markt einen deutlichen Kapitalverlust verursachen. Unsere Handelsplattform überprüft automatisch Ihre Marginanforderungen vor der Ausführung einer Order (Auftrag) und überprüft die Höhe des verfügbaren Kapitals, bevor eine Aufforderung für eine Auszahlung gemacht wird.
                          <br><br>
                          Die Marginanforderungen sind mit Erhöhungen des Exposure im Konto relevant, entweder durch das Öffnen/Schließen von Geschäften oder durch Anfragen für Auszahlungen, während es im Konto offene Positionen gibt.
                          </p>
                            <span id="product_section"></span>
                            <p class="tc-inner-link"><a href="/trading-conditions/currencies">Währungen</a></p>
                            <p class="tc-inner-link"><a href="/trading-conditions/commodities">Rohstoffe</a></p>
                            <p class="tc-inner-link"><a href="/trading-conditions/indices">Indizes</a></p>
                            <p class="tc-inner-link"><a href="/trading-conditions/shares">Aktien</a></p>
                            <p class="tc-inner-link"><a href="/trading-conditions/etfs">ETFs</a></p>
                            <p class="tc-inner-link"><a href="/trading-conditions/crypto">Kryptos</a></p>`,
  
          data_id: "",
          content_after: "",
        },
        {
          //id: "trading_hours",
          id: "tc-view-2",
          title: "Handelszeiten",
          content_before: `<p>Während des europäischen und nordamerikanischen Winters, beginnt die wöchentliche Tradingaktivität am Sonntag um 22:05 GMT und dauert bis Freitag, 21:00 GMT. Während der Winterzeit in diesen Regionen, beginnt die wöchentliche Marktaktivität am Sonntag um 21:05 GMT und endet am Freitag um 20:00. Markthandelsstunden können aufgrund von gesetzlichen Feiertagen oder aufgrund von ungewöhnlichen Liquiditätsbedingungen, die auf außergewöhnlichen globalen Ereignissen beruhen, variieren. Eröffnungs- und Schließungszeiten können ebenfalls aufgrund von Liquiditäts- und Risikomanagementüberlegungen durch iFOREX Europe geändert werden.
              <br><br>
              Obwohl die meisten der Instrumente auf einer 24 Stunden Basis ohne Unterbrechung gehandelt werden, haben einige Instrumente spezielle Handelszeiten, wie der folgenden Tabelle zu entnehmen ist:
              </p>`,
  
          data_id: "TradingHours",
          products: {
            1:"Währungen & Krypto",
            2:"Rohstoffe",
            3:"Indizes",
            4:"Aktien",
            5:"Precious Metals Spot",
            8:"ETFs"
          },
          table_titles: [
            "Markt",
            "Börsenstunden (GMT)	",
            "Zeit der 1. täglichen Pause (GMT)",
            "Zeit der 2. täglichen Pause (GMT)",
            "Daten gültig bis (GMT)"
          ],
          content_after: `<p>Sind Sie nicht sicher, welcher Markt das Instrument beinhaltet, nach dem Sie suchen? Klicken Sie <span class="tclink" target-tab="tc-view-6">hier</span> für eine vollständige Liste von Instrumenten pro Markt.</p>`,
        },
        {
          //id: "holidays",
          id: "tc-view-4",
          title: "Feiertage",
          content_before: `<p>
              Um sicherzustellen, dass Sie über alle Marktzeiten und Feiertage informiert sind, finden Sie unten eine Liste von Ereignissen, die die Handelszeiten verändern könnten.<br>
              Bei iFOREX Europe tun wir unser Bestes, um diese Information auf dem aktuellsten Stand zu halten.<br>
              Sollten Sie mehr Informationen erhalten möchten, kontaktieren Sie gerne unseren Dealing Desk.
              </p>`,
  
          data_id: "Holidays",
          table_titles: [
            "Markt",
            "Aussetzen des Handelns um (GMT)",
            "Fortsetzen des Handelns um (GMT)",
          ],
          content_after: `<p class="mt-4">Sind Sie nicht sicher, welcher Markt das Instrument beinhaltet, nach dem Sie suchen? Klicken Sie <span class="tclink" target-tab="tc-view-6">hier</span> für eine vollständige Liste von Instrumenten pro Markt.</p>`,
        },
        {
          //id: "orders_and_execution",
          id: "tc-view-23",
          title: "Aufträge und Ausführung",
          content_before: `<p><b>Orderarten</b></p>
          <table class="mb-4 table4">
             <tbody>
                <tr>
                   <th>Market-Order</th>
                   <th></th>
                </tr>
                <tr>
                   <td>Geschäft eröffnen</td>
                   <td>Eine Order zur Eröffnung einer Position zum aktuell verfügbaren Marktpreis</td>
                </tr>
                <tr>
                   <td>Geschäft schließen</td>
                   <td>Eine Order zum Schließen einer Position zum aktuell verfügbaren Marktpreis</td>
                </tr>
             </tbody>
          </table>
          <table class="mb-4 table4">
             <tbody>
                <tr>
                   <th>LIMIT-ORDER</th>
                   <th></th>
                </tr>
                <tr>
                   <td>Stop Loss</td>
                   <td>Stop Loss ist eine Order zum Öffnen oder Schließen eines Geschäftes bei einem Kurs, der schlechter ist als der aktuelle Marktpreis.</td>
                </tr>
                <tr>
                   <td>Take Profit</td>
                   <td>Take Profit ist eine Order zum Öffnen oder Schließen eines Geschäftes bei einem Kurs, der besser ist als der aktuelle Marktpreis.</td>
                </tr>
             </tbody>
          </table>
          <p>
             <b>Market-Order</b><br>Market Orders (Handelsaufträge, Open Deal, Close Deal) werden zu dem Preis ausgeführt, der auf der Handelsplattform der Gesellschaft zum Zeitpunkt der Ausführung gültig ist, sofern dieser Preis innerhalb eines vorgegebenen Toleranzniveaus liegt, das auf dem Server der Gesellschaft angegeben ist, und unabhängig davon, ob der zugrunde liegende Kurs über oder unter dem aktuellen Preis auf der Handelsplattform liegt (What You See Is What You Get oder WYSIWYG). Für den Fall, dass der aktuelle Preis auf der Handelsplattform (Kundenseite) das oben genannte Toleranzniveau überschreitet, zum Beispiel aufgrund von Bewegungen der zugrunde liegenden Vermögenswerte zwischen dem Zeitpunkt, zu dem ein Kunde seinen Auftrag erteilt hat, und dem Zeitpunkt, zu dem er empfangen und ausgeführt wird, hohe Volatilität und Kommunikationslatenz herrscht, wird der Auftrag zu dem aktuellen Preis auf dem Server der Gesellschaft ausgeführt, der sich von dem auf der Handelsplattform (Marktpreis) festgelegten Preis symmetrisch unterscheidet. Im Falle eines erheblichen Unterschieds zwischen dem auf der Handelsplattform (Kundenseite) angegebenen Preis und dem aktuellen Preis auf den Servern der Gesellschaft wird die Bestellung abgelehnt.
          </p>
          <p>
             <b>Limit Orders</b><br>Limit Orders (Futures) werden zu dem aktuellen Marktpreis auf dem Server des Unternehmens ausgeführt, der unterschiedlich zu dem aktuellen Preis im Auftrag (Slippage) sein kann. Slippage kann auftreten, wenn der in der Bestellung angegebene Preis nicht auf dem Server verfügbar ist, zum Beispiel aufgrund hoher Volatilität und Marktlücken. In diesem Fall wird die Bestellung, unabhängig von der Schlupfrichtung, ob zu Gunsten des Kunden oder nicht, in symmetrischer und transparenter Weise (Symmetrical Slippage) ausgeführt.<br><br>Instrumente (z. B. Aktien und Indizes), die nicht auf einer 24-Stunden-Basis gehandelt werden, können täglich einer Marktlücke ausgesetzt sein und sind daher anfälliger für Slippage. Es ist wichtig anzumerken, dass Slippage keinen Einfluss auf den Negativbilanzschutz hat und somit der Kunde nie mehr als den investierten Betrag (einschließlich eines allfälligen Gewinns) verliert, auch wenn ein Slippage eintritt.<br><br>Bitte beachten Sie: Sollte der Kunde einen Limit Auftrag zu dessen offen(en) Geschäft(en) gesetzt haben, können einige oder alle dieser Geschäfte aufgrund des verpflichtenden Margen-Ausschluss-Absicherungs-Mechanismus automatisch geschlossen werden, bevor die entsprechenden Limit Aufträge erreicht werden. Für weitere Informationen zur verpflichtenden Margen-Ausschluss-Absicherung, lesen Sie bitte den weiter unten aufgeführten Tab zu „Margen Information“.
          </p>
          <p>
             <b>Verzögerungen bei der Ausführung</b><br>Eine Verzögerung bei der Ausführung von Orders kann aus verschiedenen Gründen vorkommen wie technische Probleme mit dem Internet des Kunden, der mobilen oder sonstigen Kommunikationsverbindung mit den iFOREX Europe Servern, was zu „hängenden Aufträgen“ (hanging orders) führen kann. Eine Störung im Verbindungspfad kann manchmal das Signal unterbrechen und die Plattform deaktivieren, was Verzögerungen der Datenübermittlung zwischen der Plattform des Traders und dem iFOREX Europe Server verursacht.
          </p>
          <p>
             <b>Hängende Aufträge (Hanging Orders)</b><br>In Perioden mit starker Handelsvolumina oder Kommunikationslatenz kann es zu hängenden Aufträgen kommen. Der Anstieg eingehender Orders kann manchmal Bedingungen schaffen, in denen es zu Verzögerungen bei der Bestätigung/Verarbeitung bestimmter Limit-Orders kommen kann. In manchen Fällen kann die Position tatsächlich ausgeführt worden sein und die Verzögerung besteht lediglich bei der Anzeige der Seite beim Kunden, ausgelöst durch den starken Internet Traffic.<br><br>Beachten Sie, dass die Eingabe jeder Order nur einmal erforderlich ist. Mehrfacheingaben für die gleiche Order können den Computer verlangsamen oder sperren oder versehentlich unerwünschte Positionen eröffnen.
          </p>`,
  
          data_id: "",
          content_after: "",
        },
        {
          //id: "negative_balance_protection",
          id: "tc-view-20",
          title: "Schutz vor negativem Saldo",
          content_before: `<p>
                            iFOREX Europe arbeitet mit einer Politik zum Schutz vor negativem Saldo, die dem Kunden garantiert, dass die Verluste des Kunden auf das im Kundenkonto investierte Kapital begrenzt sind. Nach dieser Maßgabe soll der Kunde nie mit einem Sollsaldo aufgrund von Handelsverlusten konfrontiert werden, wenn er mit iFOREX Europe tradet und der potentielle Kundenverlust soll auf die im Kundenkonto eingezahlten und der eventuell im Zuge des Tradens erwirtschafteten Gewinne begrenzt sein.
                            </p>`,
          data_id: "",
          content_after: "",
        },
        {
  //id: "margin_information",
  id: "tc-view-24",
  title: "Margen Information",
  content_before: `
    <p>
      Das unten angezeigte Fenster bietet detaillierte Informationen zum Margin eines Kontos:
      <div class="table-wrapper">
        <table class="table3 mt-4 mb-4">
          <tbody>
            <tr>
              <td>Eigenkapital</td>
              <td>€4.995</td>
            </tr>
            <tr>
              <td>Genutzte Marge</td>
              <td>€2.500</td>
            </tr>
            <tr>
              <td>Verfügbare Marge</td>
              <td>€2.495</td>
            </tr>
            <tr>
              <td>Margennutzung</td>
              <td style="color:green">50,05%</td>
            </tr>
            <tr>
              <td>Mindest-Marge</td>
              <td>€1.250</td>
            </tr>
            <tr>
              <td>Nettoengagement</td>
              <td>€250.000</td>
            </tr>
            <tr>
              <td>Marge-Abdeckung</td>
              <td>1,498%</td>
            </tr>
          </tbody>
        </table>
      </div>

      <ul class="list-style-disc-small mb-3">
        <li>
           <b>Das Eigenkapital</b> spiegelt den Echtzeitwert Ihres Kontos wider. Es umfasst Ihren Kontostand und den Gewinn/Verlust aus offenen Positionen.
        </li>

        <li>
          <b>Genutzte Marge</b> zeigt den Betrag des Eigenkapitals in einem Konto, der derzeit als Marge für Ihre offenen Geschäfte verwendet wird. Wenn die genutzte Marge gleich oder größer als das Eigenkapital ist, bedeutet dies, dass die Hebelwirkung des Kontos maximiert ist.
        </li>

        <li>
           <b>Die Verfügbare Marge</b> zeigt den Betrag des Eigenkapitals auf einem Konto, der derzeit nicht verwendet wird und für eine weitere Erhöhung des Nettoengagements zur Verfügung steht. Ist die verfügbare Marge gleich Null, bedeutet dies, dass die maximale Hebelwirkung auf dem Konto ausgeschöpft ist.<br>
          Verfügbare Marge = Eigenkapital – Genutzte Marge
        </li>

        <li>
           <b>Die Margennutzung</b> gibt den Prozentsatz des Eigenkapitals an, der als Marge für die derzeit offenen Geschäfte des Kontos verwendet wird. Eine Margennutzung von 100&nbsp;% und mehr bedeutet, dass die maximale Hebelwirkung des Kontos ausgeschöpft ist.<br>
          Margennutzung % = (Genutzte Marge / Eigenkapital) x 100
        </li>

        <li>
           <b>Die Mindest-Marge</b> entspricht 50&nbsp;% der genutzten Marge, die erforderlich ist, um Ihre offenen Geschäfte zu halten. Wenn Ihr Eigenkapital auf diesen Wert fällt oder darunter liegt, wird automatisch ein Margin-Close-out-Schutz (wie unten definiert) ausgelöst.<br>
          Mindest-Marge = Genutzte Marge x 0,5
        </li>

        <li>
           <b>Margeabdeckung</b> ist der Prozentsatz des Risikos, der durch Gelder gedeckt ist.Sie spiegelt die maximale Änderung des Marktpreises gegen die Richtung der offenen Geschäfte wider, die durch Mittel gedeckt sind (bis die Mindest-Marge erreicht ist).<br>
          Marge-Abdeckung = (Eigenkapital - Mindest-Marge) / Nettoexposition
        </li>
      </ul>

      <b>Margin-Close-out-Schutz</b><br>
      Sollten die im Eigenkapital eines Kunden verfügbaren Mittel der Mindest-Marge entsprechen oder darunter liegen, schließt iFOREX Europe automatisch das Geschäft, das den größten Teil der verwendeten Marge verbraucht, um die niedrigstmögliche Mindest-Marge zu erreichen (Schließung nur offener Geschäfte auf Instrumente, die zu diesem Zeitpunkt gemäß den veröffentlichten Handelszeiten offen sind). Sollten zu diesem Zeitpunkt keine offenen Geschäfte auf Instrumenten offen sein, wird das offene Geschäft auf dem Instrument, das zuerst eine Notierung erhält, zuerst automatisch geschlossen. Wenn es mehrere Geschäfte (mehr als eines) gibt, die den größten Teil der verwendeten Marge gleichermaßen verbrauchen, schließt das Unternehmen automatisch das Geschäft, das zuerst eröffnet wurde. Falls die niedrigstmögliche Mindest-Marge nicht durch das automatische Schließen eines einzelnen Geschäfts erreicht werden kann, schließt das Unternehmen automatisch alle offenen Geschäfte unter einem bestimmten Instrument. iFOREX Europe ermöglicht seinen Kunden die vollständige Nutzung nicht realisierter Gewinne aus ihren offenen Geschäften, um ihre verlustbringenden Geschäfte zu unterstützen. 
      <br><br>

      <b><u><u>Beispiele</u></u></b><br><br>

      <b>Beispiel I</b><br>
      Dieses Beispiel betrifft eine Situation, in der ein Kunde mehrere Geschäfte offen hält und das Eigenkapital des Kontos einen Wert erreicht, der gleich oder kleiner als die Mindest-Marge ist:<br><br>
      <ul class="list-style-disc-small mb-3">
        <li>Offene Geschäfte:</li>
        <ul class="list-style-disc-small empty-disc ml-4">
          <li>1 EUR/USD-Geschäft: KAUF €60.000 @ Kurs 1,1750 (Erforderliche anfängliche genutzte Marge = 3,33% x €60.000 = €1.998)</li>
          <li>1 Germany 40-Geschäft: KAUF 4 Kontrakte @ Kurs 12.500 (Erforderliche anfängliche genutzte Marge = 5% x 4 x €12.500 = €2.500)</li>
          <li>1 WTI-Öl-Geschäft: KAUF 500 Barrel @ Kurs 70,00 oder 59,56 pro Barrel, wenn der Wert in Euro angegeben ist (Erforderliche anfängliche genutzte Marge = 10% x 500 x €59,56 = €2.978)</li>
        </ul>
        <li>Genutzte Marge = €1.998 + €2.500 + €2.978 = €7.476</li>
        <li>Mindest-Marge-Niveau = €3.738</li>
      </ul>
      Sobald das Eigenkapital des Kontos einen Wert von €3.738 erreicht oder darunter liegt, wird der Marge-Close-out-Schutz ausgelöst, indem das Geschäft mit der größten genutzten Marge geschlossen wird, nämlich der KAUF von 500 Barrel WTI-Öl</b>.
      <br><br>

      <b>Beispiel II</b><br>
      Dieses Beispiel betrifft eine Situation, in der ein Kunde mehrere Geschäfte offen hält und das Eigenkapital des Kontos einen Wert erreicht, der gleich oder kleiner als die Mindest-Marge ist:<br><br>
      <ul class="list-style-disc-small mb-3">
        <li>Offene Geschäfte:</li>
        <ul class="list-style-disc-small empty-disc ml-4">
          <li>2 USD/JPY-Geschäfte: KAUF $100.000 (Erforderliche anfängliche genutzte Marge = 3,33% x $100.000 = $3.330), VERKAUF 80.000 (Erforderliche anfängliche genutzte Marge = 3,33% x $80.000 = $2.664)</li>
          <li>1 USD/PLN -Geschäft: VERKAUF $80.000 (Erforderliche anfängliche genutzte Marge = 5% x $80.000 = $4.000)</li>
        </ul>
        <li>Genutzte Marge = ($3.330 – $2.664) + $4.000 = $4.666</li>
        <li>Mindest-Marge-Niveau = $2.333</li>
      </ul>
      Sobald das Eigenkapital des Kontos einen Wert von $2.333 erreicht oder darunter liegt, wird der Marge-Close-out-Schutz ausgelöst, indem das Geschäft mit der größten genutzten Marge geschlossen wird, nämlich der <b>VERKAUF von $80.000 USD/PLN</b>.
      <br><br>
      Bitte beachten Sie:<br><br>
      <ul class="list-style-disc-small mb-3">
        <li>Durch den Abschluss des Verkaufs von USD/JPY im Wert von 80.000 $ würde sich das Nettoengagement in USD/JPY von 20.000 $ auf 100.000 $ erhöhen, wodurch sich die verwendete Marge um 2.664 $ erhöhen würde ⇾ (100.000 $ x 3,33 %) - (20.000 x 3,33 %) = 3.330 $ - 666 $ = +<u>2.664 $ </u></li>
        <li>Durch den Abschluss des Kaufs von USD/JPY im Wert von 100.000 USD würde sich das Nettoengagement in USD/JPY von 20.000 USD auf 80.000 USD erhöhen, wodurch sich die verwendete Marge um 1.998 USD erhöhen würde ⇾ (80.000 USD x 3,33 %) – ($20.000 x 3,33 %) = $2.664 - $666 = +<u>$1.998 </u></li>
        <li>Durch das Schließen des Verkaufs von USD/INR im Wert von 80.000 $ würde sich das Nettoengagement in USD/INR von 80.000 $ auf 0 verringern, sodass sich die <b>verwendete Marge um 4.000 $ verringern würde</b></li>
      </ul>

      <b>Beispiel III</b><br>
      Dieses Beispiel betrifft eine Situation, in der ein Kunde mehrere offene Geschäfte hält, jedoch die niedrigstmögliche Maintenance Marge nicht durch automatisches Schließen eines einzelnen Geschäfts erreicht werden kann: <br><br>
      <ul class="list-style-disc-small mb-3">
        <li>Offene Geschäfte:</li>
        <ul class="list-style-disc-small empty-disc ml-4">
          <li>3 USD/JPY-Geschäfte: KAUF von 100.000 $ (anfänglich erforderliche genutzte Marge = 3,33 % x 100.000 $ = 3.330 $), VERKAUF von 70.000 $ (erforderliche anfängliche Marge = 3,33 % x 70.000 $ = 2.331 $), VERKAUF von 10.000 $ (erforderliche anfängliche Marge = 3,33 % x 10.000 $ = 333 $). </li>
          <li>2 USD/PLN-Geschäft: Verkauf von 10.000 $ (erforderliche anfängliche Marge = 5 % x 10.000 $ = 500 $), Kauf von 8.000 $ (erforderliche anfängliche Marge = 5 % x 8.000 $ = 400 $) </li>
          <li>2 USD/INR-Geschäft: VERKAUF von 10.000 $ (erforderliche anfängliche Marge = 5 % x 10.000 $ = 500 $), KAUF von 7.000 $ (erforderliche anfängliche Marge = 5 % x 7.000 $ = 350 $) </li>
        </ul>
        <li>Genutzte Marge = ($3.330 – $2.331 – $333) + ($500 - $400) + ($500 - $350) = $916</li>
        <li>Mindest-Marge-Niveau = $458</li>
      </ul>
      In diesem Fall werden, sobald das Eigenkapital einen Wert von 458 USD oder weniger erreicht, die Geschäfte auf dem Konto automatisch auf Instrumentenebene geschlossen, basierend auf dem Instrument mit dem höchsten Nettoengagement. Daher werden <b>alle USD/JPY-Geschäfte</b> geschlossen. 
      <br><br>
      Bitte beachten Sie:<br><br>
      <ul class="list-style-disc-small mb-3">
        <li>Das Schließen eines beliebigen Geschäfts würde die Nettoexposition erhöhen, wodurch die <b>genutzte Marge steigen würde</b>.</li>
        <li>Durch das Schließen aller USD/JPY-Geschäfte wird das Nettoengagement um 20.000 $ reduziert, sodass die <b>verwendete Marge um 666 $</b> sinkt. Dies ist mehr als beim Schließen von USD/PLN-Geschäften, wodurch die verwendete Marge um 100 $ sinkt, oder USD/INR-Geschäften, wodurch die verwendete Marge um 150 $ sinkt. </li>
      </ul>
    </p>
  `,
  data_id: "",
  content_after: ""
}
,
        {
          //id: "additional_trading_rules",
          id: "tc-view-25",
          title: "Ergänzende Handelsvorschriften",
          content_before: `
              <p>
              <b>Maximales Exposure</b><br>
              Als Vorsichtsmaßnahme zur Verbesserung des Risikomanagements und zur Vermeidung übermäßiger Konzentrationsrisiken auf einen einzigen Kunden, hat iFOREX Europe eine Begrenzung des Netto-Exposures pro Kunde auf maximal 12 (zwölf) Millionen Euro festgesetzt. iFOREX Europe hat zudem ein maximales Netto-Exposure pro Instrument festgelegt. <span class="tclink" target-tab="tc-view-6" target-section="product_section">Klicken Sie hier</span>, um das maximale Exposure pro Instrument anzusehen. iFOREX Europe hat das Recht, nach eigenem Ermessen, jederzeit und ohne vorherige Ankündigung eine solche Begrenzung abzuschaffen oder zu ändern.
              <br><br>
              <b>Absicherung (Hedging)</b><br>
              Absicherung (Hedging) von Transaktion ist die Eröffnung von zwei Geschäften auf das gleiche Instrument oder den gleichen Basiswert in verschiedene Richtungen (eine "buy"/kaufen und eine "sell"/verkaufen) gegebenenfalls zur gleichen Zeit und in gleicher Menge. iFOREX Europe berücksichtigt Absicherungsgeschäfte bei der Kalkulation der Mindestmargin auf kumulierter Basis oder auf "Netto"-Basis. Ferner betrachtet iFOREX Europe das Schließen eines abgesicherten Geschäftes als die Eröffnung einer neuen Transaktion, deren Betrag der verbleibenden (nicht abgesicherten) Transaktion entspricht.
              <br><br>
              <b>Netting von Transaktionen</b><br>
              In dem Fall, dass in einem Konto mehr als ein Geschäft gleichzeitig geschlossen werden muss, wird iFOREX Europe Sammelschließungen für alle offenen Positionen vornehmen.<br>Die jeder geschlossenen Position zugeordnete Transaktionsnummer wird nach FIFO-Regeln festgelegt. Das bedeutet, dass beim Schließen der Positionen, die Position, die als erstes eröffnet wurde, die niedrigste Transaktionsnummer erhält und die letzte Position, die eröffnet wird, die höchste Transaktionsnummer erhält.
              <br><br>
              <b>Nicht Autorisierte Handelspraktiken</b><br>
              iFOREX Europe unterstützt den fairen Handel und erlaubt keine Praktiken, die missbräuchliches Traden darstellen wie Lag Trading, Preismanipulation, Zeitmanipulation oder jegliche andere Praktiken, die illegal sind und/oder genutzt werden, um einen unfairen Vorteil zu erzielen. Beispiele für solche verbotenen Praktiken könnten, aber nicht abschließend, folgende sein:
              <ul class="list-style-disc-small mt-3 mb-2">
                  <li>
                    <b>Scalping</b> ist eine Handelsstrategie, mit der versucht wird, kleine Kursveränderungen auszunutzen. Trader, die diese Strategie anwenden, gehen viele kurzfristige Positionen ein und schließen sie in der Regel innerhalb von Sekunden oder Minuten.
                  </li>
                  <li>
                    <b>Automation</b> (z.B. EAs) oder algorithmisches Trading ist der Gebrauch von elektronischen Plattformen zur Eingabe von Trading Orders mit einem Algorithmus, der programmierte Trading-Anweisungen ausführt, deren Variablen Timing, Preis und Menge der Order beinhalten können oder in vielen Fällen die Order durch einen "Roboter", ohne menschliche Intervention, initiiert.
                  </li>
                  <li>
                    <b>API Trading</b> ist eine Schnittstelle für Anwendungsprogrammierung, die sich auf Formen des Tradens bezieht, die ein Software-Programm verwenden, um mit anderen Programmen zu interagieren. Die API fungiert als Vermittler zwischen dem Trader und dem Markt und setzt nach Bedarf Orders um und ruft Informationen ab.
                  </li>
                  <li>
                    <b>'Multiple accounts'</b> (mehrere Konten) bezeichnet zwei oder mehrere Konten, die von einem Kunden eingerichtet wurden, um unberechtigt mehrere kontobezogenen Vorteile zu erhalten, die iFOREX Europe gewährt.
                  </li>
              </ul>
              <p>Wenn das Unternehmen nach seinem alleinigen und uneingeschränkten Ermessen Anhaltspunkte oder den Verdacht auf irgendeine Form von Ausbeutung, illegalen, unfairen, nicht genehmigten und/oder missbräuchlichen Handelspraktiken hat, die genutzt werden, um dem Kunden einen unlauteren Vorteil zu verschaffen, und/oder auf Betrug, Manipulation oder Verletzung der Vereinbarungen und Richtlinien des Unternehmens, hat das Unternehmen das Recht, nach seinem alleinigen und uneingeschränkten Ermessen und ohne Einschränkung seiner Rechte im Rahmen seiner Vereinbarungen mit dem Kunden und des geltenden Rechts alle Transaktionen auf den betreffenden Konten zu annullieren und zu stornieren, einschließlich aller damit erzielten Gewinne oder Verluste, und/oder das Konto zu sperren.</p>
              <b>Fehler in Kursen</b><br>
              Online-Trading-Technologie ist nicht perfekt und in selteten Fällen kann es vorkommen, dass die Datenversorgung unterbrochen wird. Das mag nur für einen Moment andauern, aber wenn dies geschieht, können oft Preise betroffen sein. Zwar mag es verlockend erscheinen, eine "Arbitrage Transaktion" zu platzieren, denken Sie aber daran, dass in solchen Situationen die Preise nicht den wahren Marktpreis widerspiegeln und Sie in Wahrheit viele Pips vom angezeigten Preis entfernt liegen. Für den Fall, dass Trades zu einem Preis ausgeführt werden, der von iFOREX Europe eigentlich nicht angeboten wird, behält sich iFOREX Europe das Recht vor, solche Trades rückabzuwickeln, da sie nicht als gültige Trades gelten. Beachten Sie, dass diese Fälle in der Regel selten sind und Trader das mit dem oben beschriebenen Szenario verbundene Risiko vermeiden können, wenn sie in diesen Situationen nicht traden.
              <br><br>
              <b>Kontoführungsgebühr</b><br>
              Kundenkonten, auf denen seit zwölf (12) aufeinander folgenden Monaten keine Trading-Aktivität verzeichnet wurde, werden mit einer vierteljährlichen Kontoführungsgebühr in Höhe von US$15 oder in Höhe des gesamten Eigenkapitals, wenn das Eigenkapital weniger als US$15 beträgt, belastet.<br>Für Kundenkonten, die keine verfügbaren Mittel enthalten wird iFOREX Europe keine Kontoführungsgebühren belasten.
              <br><br>
              Mehr Informationen zum Handel finden Sie in unseren <a href="/legal/client-agreement.pdf">Allgemeinen Geschäftsbedingungen</a>.
              </p>
              `,
          data_id: "",
          content_after: "",
        },
      ],
    },
    {
      id: "forex",
      title: "Forex",
      tabs: [
        {
          //id: "forex_overnight_financing",
          id: "tc-view-10",
          title: "Übernachtfinanzierung",
          content_before: `
                  <p>
                  Beim gehebelten Handel von Währungen (Forex) CFD bei iFOREX Europe wird für offene Geschäfte zum Ende des jeweiligen Handelstages eine Übernachtfinanzierung angewandt. Diese Übernachtfinanzierung kann eine Gutschrift oder eine Abbuchung sein, dessen Kalkulation von den entsprechenden Zinssätzen der vorliegenden Währungen zzgl. Aufschlag abhängt. Der Aufschlag bei Währungspaaren beginnt bei 0,75% und kann sowohl höher sein als auch zwischen Long (Kaufen) und Short (Verkaufen) Positionen variieren. Bitte informieren Sie sich in der untenstehenden Tabelle über die aktuellen Niveaus der Übernachtfinanzierung.
                  <br><br>
                  Wenn der berechnete Prozentsatz der Übernachtfinanzierung positiv ist, bedeutet dies, dass der entsprechende Betrag zu Ihrem Eigenkapital des Handelskontos hinzugefügt wird.
                  <br><br>
                  Sie finden den Prozentsatz, die Beträge und die Zeiten der Übernachtfinanzierung im Tool für das Geschäft und das Limit-Geschäft im "Marktinformationen" Tab. Um den Betrag der Übernachtfinanzierung zu kalkulieren, was dem Betrag der Belastung oder Gutschrift entspricht, multiplizieren Sie einfach den Übernachtfinanzierungs-Prozentsatz mit der Größe des Geschäfts. Der Zeitpunkt der Anwendung des Übernachtfinanzierungsvorganges für jeden CFD ist in der Eingabemaske für ein Geschäft im Tab 'Instrument-Info' unter "Übernachtfinanzierung (GMT)" zu finden. Der angegebene Wert und Prozentsatz von der Übernachtfinanzierung eines Instrumentes wird für 1 Tag berechnet. CFDs die nur 5 Tage in der Woche gehandelt werden, werden 3 Mal mit dem angezeigten Wert am letzten Handelstag der Handelswoche belastet/gutgeschrieben, da dies das gesamte Wochenende abdeckt. Der Betrag der Übernachtfinanzierung wird in der Währung des CFD angezeigt. Sollte allerdings die Währung des genannten CFD von der Währung des Kontos abweichen, wird der Betrag in die Währung des Kontos umgerechnet.
                  <br><br>
                  <u><b><u>Formel</u></b></u><br><br>
                  Berechnung of Übernachtfinanzierung-Prozentsatz bei Kauf (Long Position):
                      <br>
                
  
                    <div class="formula formula_f1">
                        <div class="formula-name">Übernachtfinanzierung-Prozentsatz</div>
                        <div class="formula-equal" >=</div>
                        <div class="formula-f1">-
                            <div class="formula-sub">
                                <div class="formula-sub1">Zinssatz der anderen Währung - Zinssatz der Basiswährung + Long-Markup</div>
                                <div class="formula-sub2">360</div>
                            </div>
                        </div>
                    </div>
                    <br>
                    Berechnung of Übernachtfinanzierung-Prozentsatz bei Verkauf (Short Position):
                      <br><br>
                      
                      <div class="formula formula_f2">
                        <div class="formula-name">Übernachtfinanzierung-Prozentsatz</div>
                        <div class="formula-equal" >=</div>
                        <div class="formula-f1">
                            <div class="formula-sub">
                                <div class="formula-sub1">Zinssatz der anderen Währung - Zinssatz der Basiswährung - Short-Markup</div>
                                <div class="formula-sub2">360</div>
                            </div>
                        </div>
                    </div>

                      <br><br>

                      Um den Betrag der Übernachtfinanzierung zu kalkulieren, muss einfach der Geschäftsbetrag mit dem Prozentsatz multipliziert werden:<br><br>Übernachtfinanzierung Betrag = Geschäftsbetrag X Übernachtfinanzierung-Prozentsatz
                        <br><br><br>
                        <u><b><u>Beispiele</u></b></u><br><br>
                        <b>Beispiel I</b><br><br>
                        Dieses Beispiel zeigt eine Situation, wo die Interbank-Zinssatzdifferenz HÖHER ist als der Aufschlag. In diesem Fall wird Ihrem Konto ein Betrag belastet, wenn Sie Long Positionen öffnen und gutgeschrieben, wenn Sie Short Position öffnen.
                        <br><br>
                        <ul class="list-style-dashed mb-4">
                            <li>Handelsinstrument = EUR/USD (Euro vs. US Dollar)</li>
                            <li>Zinssatz EUR (Basiswährung) (annualisiert) = -0,37% = -0,0037</li>
                            <li>Zinssatz USD (andere Währung) (annualisiert) = 1,08% = 0,0108</li>
                            <li>Interbank-Zinssatz Differenz = 1.45% = 0.0145</li>
                            <li>Long Aufschlag = 0.75% = 0.0075</li>
                            <li>Short Aufschlag = 0.75% = 0.0075</li>
                            <li>Geschäftsbetrag in anderen Währung = 106,550 USD (100,000 EUR zum aktuellen Schlusskurs von 1.0655)</li>
                        </ul>
                        Übernachtfinanzierung-Prozentsatz bei Kauf (Long Position):<br><br>
                      
                    <div class="formula formula_f3 mb-2" >
                        <div class="formula-name">Übernachtfinanzierung-Prozentsatz</div>
                        <div class="formula-equal" >=</div>
                        <div class="formula-f1">-
                            <div class="formula-sub">
                                <div class="formula-sub1">0.0108 - (-0.0037) + 0.0075</div>
                                <div class="formula-sub2">360</div>
                            </div>
                        </div>
                        <div class="formula-equal">=</div>
                        <div class="formula-f2">-0.0000611</div>
                        <div class="formula-equal">=</div>
                        <div class="formula-f3">-0.00611%</div>
                    </div>

                    Übernachtfinanzierung Betrag = 106,550 × (-0.0000611) = -6.51 USD, bedeutet 6.51 USD Belastung pro Tag
                    <br><br><br>
                    Übernachtfinanzierung-Prozentsatz bei Verkauf (Short Position):<br><br>
                      
                      <div class="formula formula_f4 mb-2" >
                        <div class="formula-name">Übernachtfinanzierung-Prozentsatz</div>
                        <div class="formula-equal" >=</div>
                        <div class="formula-f1">
                            <div class="formula-sub">
                                <div class="formula-sub1">0.0108 - (-0.0037) - 0.0075</div>
                                <div class="formula-sub2">360</div>
                            </div>
                        </div>
                        <div class="formula-equal">=</div>
                        <div class="formula-f2">0.00001944</div>
                        <div class="formula-equal">=</div>
                        <div class="formula-f3">0.001944%</div>
                    </div>

                    Übernachtfinanzierung Betrag = 106,550 × 0.00001944 = 2.07 USD gutgeschrieben pro Tag
                    <br><br><br>
                    <b>Beispiel II</b><br><br>
                    Dieses Beispiel zeigt eine Situation, wo die Interbank-Zinssatzdifferenz HÖHER ist als der Aufschlag und die Lang- und Kurzaufschläge unterschiedlich sind. In diesem Fall wird Ihrem Konto ein Betrag belastet, unabhängig davon auf welche Marktbewegung (long/short) Sie spekulieren:
                    <br><br>
                    <ul class="list-style-dashed mb-4">
                       <li>Handelsinstrument = EUR/TRY (Euro vs. Türkische Lira)</li>
                       <li>Zinssatz EUR (Basiswährung) (annualisiert) = -0,37% = -0,0037</li>
                       <li>Zinssatz TRY (andere Währung) (annualisiert) = 22,75% = 0,2275</li>
                       <li>Interbank-Zinssatz Differenz = 23.12% = 0.2312</li>
                       <li>Long Aufschlag = 0.75% = 0.0075</li>
                       <li>Short Aufschlag = 14.00% = 0.14</li>
                       <li>Geschäftsbetrag in anderen Währung = 620,000 TRY (100,000 EUR zum aktuellen Schlusskurs von 6.2000)</li>
                    </ul>
                    Übernachtfinanzierung-Prozentsatz bei Kauf (Long Position):<br><br>
                      
                        <div class="formula formula_f5 mb-2" >
                            <div class="formula-name">Übernachtfinanzierung-Prozentsatz</div>
                            <div class="formula-equal">=</div>
                            <div class="formula-f1">-
                                <div class="formula-sub">
                                    <div class="formula-sub1">0.2275 - (-0.0037) + 0.0075</div>
                                    <div class="formula-sub2">360</div>
                                </div>
                            </div>
                            <div class="formula-equal">=</div>
                            <div class="formula-f2">-0.000663</div>
                            <div class="formula-equal">=</div>
                            <div class="formula-f3">-0.0663%</div>
                        </div>

                    
                        Übernachtfinanzierung Betrag = 620,000 × (-0.000663) = -411 TRY, bedeutet 411 TRY Belastung pro Tag (≅80 USD)
                        <br><br><br>
                        Übernachtfinanzierung-Prozentsatz bei Verkauf (Short Position):<br><br>
                      
                      <div class="formula formula_f6 mb-2" >
                            <div class="formula-name">Übernachtfinanzierung-Prozentsatz</div>
                            <div class="formula-equal">=</div>
                            <div class="formula-f1">
                                <div class="formula-sub">
                                    <div class="formula-sub1">0.2275 - (-0.0037) - 0.14</div>
                                    <div class="formula-sub2">360</div>
                                </div>
                            </div>
                            <div class="formula-equal">=</div>
                            <div class="formula-f2">0.000253</div>
                            <div class="formula-equal">=</div>
                            <div class="formula-f3">0.0253%</div>
                        </div>


                        Übernachtfinanzierung Betrag = 620,000 × 0.000253 = 157 TRY, was bedeutet 157 TRY gutgeschrieben pro Tag (≅30 USD)
                        <br><br><br>
                        <b>Beispiel III</b><br><br>
                        Dieses Beispiel zeigt eine Situation, wo die Interbank-Zinssatzdifferenz NIEDRIGER ist als der negative Aufschlag. In diesem Fall wird Ihrem Konto ein Betrag belastet, wenn Sie Short Positionen öffnen und gutgeschrieben, wenn Sie Long Positionen öffnen.
                        <ul class="list-style-dashed mt-4 mb-4">
                           <li>Handelsinstrument = USD/JPY (US Dollar gegen Japanischer Yen)</li>
                           <li>Zinssatz USD (Basiswährung) (annualisiert) = 1,08% = 1,08</li>
                           <li>Zinssatz JPY (andere Währung) (annualisiert) = -0,09% = -0,0009</li>
                           <li>Interbank-Zinssatz Differenz = -1.17% = -0.0117</li>
                           <li>Long Aufschlag = 0.75% = 0.0075</li>
                           <li>Short Aufschlag = 0.75% = 0.0075</li>
                           <li>Geschäftsbetrag in anderen Währung = 10,341,000 JPY (100,000 USD zum aktuellen Schlusskurs von 103.41)</li>
                        </ul>
                        Übernachtfinanzierung-Prozentsatz bei Kauf (Long Position):<br><br>
                      
                      
                      <div class="formula formula_f7 mb-2" >
                            <div class="formula-name">Übernachtfinanzierung-Prozentsatz</div>
                            <div class="formula-equal">=</div>
                            <div class="formula-f1">-
                                <div class="formula-sub">
                                    <div class="formula-sub1">(-0.0009) - 0.0108 + 0.0075</div>
                                    <div class="formula-sub2">360</div>
                                </div>
                            </div>
                            <div class="formula-equal">=</div>
                            <div class="formula-f2">0.00001167</div>
                            <div class="formula-equal">=</div>
                            <div class="formula-f3">0.001167%</div>
                        </div>


                        Übernachtfinanzierung Betrag = 10,341,000 ×0.00001167=120.65 JPY gutgeschrieben pro Tag (≅1.1 USD)
                        <br><br><br>
                        Übernachtfinanzierung-Prozentsatz bei Verkauf (Short Position):<br><br>
                      
                      <div class="formula formula_f8 mb-2" >
                            <div class="formula-name">Übernachtfinanzierung-Prozentsatz</div>
                            <div class="formula-equal">=</div>
                            <div class="formula-f1">
                                <div class="formula-sub">
                                    <div class="formula-sub1">(-0.0009) - 0.0108 - 0.0075</div>
                                    <div class="formula-sub2">360</div>
                                </div>
                            </div>
                            <div class="formula-equal">=</div>
                            <div class="formula-f2">-0.0000533</div>
                            <div class="formula-equal">=</div>
                            <div class="formula-f3">-0.00533%</div>
                        </div>

                        Übernachtfinanzierung Betrag = 10,341,000 ×(-0.0000533)=-551.52 JPY, bedeutet 551.52 JPY Belastung pro Tag (≅5.3 USD)
                     <br>
                  </p>`,
  
          data_id: "OvernightFinancing",
          content_after: `<p>* Die Abwicklung von Overnight-Finanzierungen kann bis zu 15 Minuten am Ende des Handelstages in Anspruch nehmen, woraufhin Ihrem Konto eine entsprechende Gutschrift oder Belastung gutgeschrieben wird.</p>`,
          table_titles: [
            "Instrument",
            "Täglicher Übernacht-Finanzierungssatz (Verkauf)",
            "Täglicher Übernacht-Finanzierungssatz (Kauf)",
            "Übernacht-Finanzierung (GMT)*",
          ],
          view_id: ["Forex"],
        },
      ],
    },
    {
      id: "index_commodity_and_crypto_cfds",
      title: "Index, Rohstoff und Krypto CFDs",
      tabs: [
        {
          //id: "index_overnight_financing",
          id: "tc-view-11",
          title: "Overnight Finanzierung",
          content_before: `
              <p>
                      Wenn Sie mit Index- und Rohstoff- und Krypto-CFDs bei iFOREX Europe handeln, wird für offene Geschäfte am Ende des jeweiligen Handelstages eine Übernachtfinanzierung angewandt. Diese Übernachtfinanzierung kann eine Gutschrift oder Abbuchung sein, dessen Kalkulation von den entsprechenden Zinssätzen der vorliegenden Währungen abhängt, plus ein Mark-up-Aufschlag. Der Aufschlag für Kryptowährungen kann aufgrund der extremen Marktbedingungen von Kryptowährungen deutlich höher sein. Bitte informieren Sie sich in der untenstehenden Tabelle über die aktuellen Niveaus der Übernachtfinanzierung.
                      <br><br>
                      Wenn der berechnete Prozentsatz der Übernachtfinanzierung positiv ist, bedeutet dies, dass der entsprechende Betrag zu Ihrem Eigenkapital des Handelskontos hinzugefügt wird.
                      <br><br>
                      Sie finden den Prozentsatz, die Beträge und die Zeiten der Übernachtfinanzierung im Tool für das Geschäft und das Limit-Geschäft im "Marktinformationen" Tab. Um den Betrag der Übernachtfinanzierung zu kalkulieren, was dem Betrag der Belastung oder Gutschrift entspricht, multiplizieren Sie einfach den Übernachtfinanzierungs-Prozentsatz mit der Größe des Geschäfts. Der Zeitpunkt der Anwendung des Übernachtfinanzierungsvorganges für jeden CFD ist in der Eingabemaske für ein Geschäft im Tab 'Instrument-Info' unter "Übernachtfinanzierung (GMT)" zu finden. Der angegebene Wert und Prozentsatz von der Übernachtfinanzierung eines Instrumentes wird für 1 Tag berechnet. CFDs die nur 5 Tage in der Woche gehandelt werden, werden 3 Mal mit dem angezeigten Wert am letzten Handelstag der Handelswoche belastet/gutgeschrieben, da dies das gesamte Wochenende abdeckt. Der Betrag der Übernachtfinanzierung wird in der Währung des CFD angezeigt. Sollte allerdings die Währung des genannten CFD von der Währung des Kontos abweichen, wird der Betrag in die Währung des Kontos umgerechnet.
                      <br><br>
                      <u><b><u>Formel</u></b></u><br><br>
                      Berechnung of Übernachtfinanzierung-Prozentsatz bei Kauf (Long Position):<br>
                  
                  <div class="formula formula_f9 mb-2">
                    <div class="formula-name">Übernachtfinanzierung-Prozentsatz</div>
                    <div class="formula-equal" >=</div>
                    <div class="formula-f1">-
                        <div class="formula-sub">
                            <div class="formula-sub1">Zinssatz + Aufschlag</div>
                            <div class="formula-sub2">360</div>
                        </div>
                    </div>
                </div>
                <br>
                Berechnung of Übernachtfinanzierung-Prozentsatz bei Verkauf (Short Position):<br><br>
                  
                  <div class="formula formula_f10 mb-2">
                    <div class="formula-name">Übernachtfinanzierung-Prozentsatz</div>
                    <div class="formula-equal" >=</div>
                    <div class="formula-f1">
                        <div class="formula-sub">
                            <div class="formula-sub1">Zinssatz - Aufschlag</div>
                            <div class="formula-sub2">360</div>
                        </div>
                    </div>
                </div>

                Um den Betrag der Übernachtfinanzierung zu kalkulieren, muss einfach der Geschäftsbetrag mit dem Prozentsatz multipliziert werden:<br><br>Übernachtfinanzierung Betrag = Geschäftsbetrag X Übernachtfinanzierung-Prozentsatz
                <br><br><br>
                <u><b><u>Beispiele</u></b></u><br><br>
                <b>Beispiel I</b><br><br>
                Dieses Beispiel zeigt eine Situation wo der Interbank-Zinssatz HÖHER als der Aufschlag ist. In diesem Fall wird Ihrem Konto ein Betrag belastet, wenn Sie Long Positionen öffnen und gutgeschrieben, wenn Sie Short Position öffnen:
                <br><br>
                <ul class="list-style-dashed">
                   <li>Handelsinstrument = Brazil Ibovespa</li>
                   <li>Brasilianischer Real (BRL) Zinssatz (annualisiert) = 9,567 % = 0,09567</li>
                   <li>Aufschlag = 2.5% = 0.025</li>
                   <li>Geschäftsbetrag Wert in Währung = 127,380 BRL (2 Indizes Kontrakte zum aktuellen Schlusspreis von 63690 BRL per Kontrakt)</li>
                </ul>
                <br>
                Übernachtfinanzierung-Prozentsatz bei Kauf (Long Position):<br><br>
                  
                  <div class="formula formula_f11 mb-2">
                    <div class="formula-name">Übernachtfinanzierung-Prozentsatz</div>
                    <div class="formula-equal" >=</div>
                    <div class="formula-f1">-
                        <div class="formula-sub">
                            <div class="formula-sub1">0.09567 + 0.025</div>
                            <div class="formula-sub2">360</div>
                        </div>
                    </div>
                    <div class="formula-equal">=</div>
                    <div class="formula-f2">-0.0003351944</div>
                    <div class="formula-equal">=</div>
                    <div class="formula-f3">-0.03351944%</div>
                </div>

                Übernachtfinanzierung Betrag = 127,380 × (-0.0003351944) = -42.70 BRL, bedeutet 42.70 BRL Belastung pro Tag (≅13.58 USD)
                <br><br><br>
                Übernachtfinanzierung-Prozentsatz bei Verkauf (Short Position):<br><br>
                  
                  <div class="formula formula_f12 mb-2">
                    <div class="formula-name">Übernachtfinanzierung-Prozentsatz</div>
                    <div class="formula-equal" >=</div>
                    <div class="formula-f1">
                        <div class="formula-sub">
                            <div class="formula-sub1">0.09567 - 0.025</div>
                            <div class="formula-sub2">360</div>
                        </div>
                    </div>
                    <div class="formula-equal">=</div>
                    <div class="formula-f2">0.00019630556</div>
                    <div class="formula-equal">=</div>
                    <div class="formula-f3">0.019630556%</div>
                </div>

                Übernachtfinanzierung Betrag = 127,380 × 0.00019630556 = 25 BRL credit per day (≅7.95 USD)
                <br><br><br>
                <b>Beispiel II</b><br><br>
                Dieses Beispiel zeigt eine Situation wo der Interbank-Zinssatz NIEDRIGER als der Aufschlag ist. In diesem Fall wird Ihrem Konto ein Betrag belastet, unabhängig davon auf welche Marktbewegung (long/short) Sie spekulieren:
                <br><br>
                <ul class="list-style-dashed mb-4">
                   <li>Handelsinstrument = Oil (Crude Light WTI)</li>
                   <li>US-Dollar (USD) Zinssatz (annualisiert) = 1,08 % = 0,0108</li>
                   <li>Aufschlag = 2.5% = 0.025</li>
                   <li>Geschäftsbetrag Wert in Währung = 53,250 USD (1,000 Barrels Öl zum aktuellen Schlusskurs von 53.25 USD pro Barrel)</li>
                </ul>
  
                Übernachtfinanzierung-Prozentsatz bei Kauf (Long Position):
                <br>
                  <br>

                  <div class="formula formula_f13 mb-2">
                        <div class="formula-name">Übernachtfinanzierung-Prozentsatz</div>
                        <div class="formula-equal">=</div>
                        <div class="formula-f1">-
                            <div class="formula-sub">
                                <div class="formula-sub1">0.0108 + 0.025</div>
                                <div class="formula-sub2">360</div>
                            </div>
                        </div>
                        <div class="formula-equal">=</div>
                        <div class="formula-f2">-0.00009944</div>
                        <div class="formula-equal">=</div>
                        <div class="formula-f3">-0.009944%</div>
                    </div>

                    Übernachtfinanzierung Betrag = 53,250 × (-0.00009944) = -5.30 USD, bedeutet 5.30 USD Belastung pro Tag
                    <br><br><br>
                    Übernachtfinanzierung-Prozentsatz bei Verkauf (Short Position):<br><br>
                  
                  <div class="formula formula_f14 mb-2">
                        <div class="formula-name">Übernachtfinanzierung-Prozentsatz</div>
                        <div class="formula-equal">=</div>
                        <div class="formula-f1">
                            <div class="formula-sub">
                                <div class="formula-sub1">0.0108 - 0.025</div>
                                <div class="formula-sub2">360</div>
                            </div>
                        </div>
                        <div class="formula-equal">=</div>
                        <div class="formula-f2">-0.00003944</div>
                        <div class="formula-equal">=</div>
                        <div class="formula-f3">-0.003944%</div>
                    </div>

                    Übernachtfinanzierung Betrag = 53,250 × (-0.00003944) = -2.10 USD, bedeutet 2.10 USD Belastung pro Tag
                  <br><br>
                  
              </p>`,
          data_id: "OvernightFinancing",
          content_after: `<p>* Die Abwicklung von Overnight-Finanzierungen kann bis zu 15 Minuten am Ende des Handelstages in Anspruch nehmen, woraufhin Ihrem Konto eine entsprechende Gutschrift oder Belastung gutgeschrieben wird.</p>`,
          table_titles: [
            "Instrument",
            "Täglicher Übernacht-Finanzierungssatz (Verkauf)",
            "Täglicher Übernacht-Finanzierungssatz (Kauf)",
            "Übernacht-Finanzierung (GMT)*",
          ],
          view_id: ["Index", "Commodity", "Crypto"],
        },
        {
        //id: "contracts_rollover_dates",
        id: "tc-view-3",
          title: "Rollover Termine für Kontrakte",
          content_before: `<p>
                      Jeder CFD, der auf zukünftigen Kontrakten (zB. Rohstoffe und Indizes) basiert, hat ein Rollover Datum.
                      <br><br>
                      Bei Erreichen des Rollover Datums des relevanten Instruments werden alle offenen CFD Positionen auf den nächsten Vertrag umgerollt, so dass die Positionen mit dem neuen Future Vertrag offen bleiben.
                      <br><br>
                      Nach Vornahme eines solchen Rollovers wird der offene G/V (Gewinn/Verlust) die Preisdifferenz zwischen dem abgelaufenen und neuen Kontrakt-Preisen anzeigen, sowie den Spread-Aufschlag. Alle damit verbunden Limit Order Niveaus werden automatisch entsprechend dem neuen Future Kontrakt Preis angepasst.
                      <br><br>
                      Beispielsweise wenn der letzte Preis des WTI Öl Februar Kontrakt bei $50.125 und der Marktpreis des Nachfolgenden Kontraktes (März) bei $50.805 ist, dann werden die ausstehenden Limit Orders um $0.68 nach oben angepasst.
                      <br><br>
                      Das Rollover Datum des Kontraktes hängt vom jeweils gehandelten Instrument ab. Die nachfolgenden Roller Termine sind die, die auch tatsächlich auf iFOREX Europe CFD angewandt werden:
                  </p>`,
  
          data_id: "FuturesRollover",
          content_after: ``,
          table_titles: ["Kontraktmonat", "Kontrakt-Rollover Datum und Uhrzeit (GMT)"],
          view_id: ["Commodity", "Index"],
          products: ["Rohstoffe", "Indizes"],
        },
      ],
    },
    {
      id: "Share and ETF CFDs",
      title: "Aktien und ETF CFD",
      tabs: [
        {
          //id: "shares_overnight_financing",
          id: "tc-view-12",
          title: "Overnight Finanzierung",
          content_before: `<p>
                      Beim Handel von Aktien- und ETF-CFDs bei iFOREX Europe wird für offene Geschäfte zum Ende des jeweiligen Handelstages eine Übernachtfinanzierung angewandt. Diese Übernachtfinanzierung kann eine Gutschrift oder eine Abbuchung sein, dessen Kalkulation von den entsprechenden Zinssätzen der vorliegenden Währungen, plus ein Mark-up-Aufschlag. Bitte informieren Sie sich in der untenstehenden Tabelle über die aktuellen Niveaus der Übernachtfinanzierung.
                      <br><br>
                      Wenn der berechnete Prozentsatz der Übernachtfinanzierung positiv ist, bedeutet dies, dass der entsprechende Betrag zu Ihrem Eigenkapital des Handelskontos hinzugefügt wird.
                      <br><br>
                      Sie finden den Prozentsatz, die Beträge und die Zeiten der Übernachtfinanzierung im Tool für das Geschäft und das Limit-Geschäft im "Marktinformationen" Tab. Um den Betrag der Übernachtfinanzierung zu kalkulieren, was dem Betrag der Belastung oder Gutschrift entspricht, multiplizieren Sie einfach den Übernachtfinanzierungs-Prozentsatz mit der Größe des Geschäfts. Der Zeitpunkt der Anwendung des Übernachtfinanzierungsvorganges für jeden CFD ist in der Eingabemaske für ein Geschäft im Tab 'Instrument-Info' unter "Übernachtfinanzierung (GMT)" zu finden. Der angegebene Wert und Prozentsatz von der Übernachtfinanzierung eines Instrumentes wird für 1 Tag berechnet. CFDs die nur 5 Tage in der Woche gehandelt werden, werden 3 Mal mit dem angezeigten Wert am letzten Handelstag der Handelswoche belastet/gutgeschrieben, da dies das gesamte Wochenende abdeckt. Der Betrag der Übernachtfinanzierung wird in der Währung des CFD angezeigt. Sollte allerdings die Währung des genannten CFD von der Währung des Kontos abweichen, wird der Betrag in die Währung des Kontos umgerechnet.
                      <br><br>
                      <u><b><u>Formel</u></b></u><br><br>
                      Berechnung of Übernachtfinanzierung-Prozentsatz bei Kauf (Long Position):
                      <br>
             
                  
                  <div class="formula formula_f15 mb-2">
                    <div class="formula-name">Übernachtfinanzierung-Prozentsatz</div>
                    <div class="formula-equal" >=</div>
                    <div class="formula-f1">-
                        <div class="formula-sub">
                            <div class="formula-sub1">Zinssatz + Aufschlag</div>
                            <div class="formula-sub2">360</div>
                        </div>
                    </div>
                </div>
                <br>
                Berechnung of Übernachtfinanzierung-Prozentsatz bei Verkauf (Short Position):
                <br><br>

                <div class="formula formula_f16 mb-2">
                    <div class="formula-name">Übernachtfinanzierung-Prozentsatz</div>
                    <div class="formula-equal" >=</div>
                    <div class="formula-f1">
                        <div class="formula-sub">
                            <div class="formula-sub1">Zinssatz - Aufschlag</div>
                            <div class="formula-sub2">360</div>
                        </div>
                    </div>
                </div>


                Um den Betrag der Übernachtfinanzierung zu kalkulieren, muss einfach der Geschäftsbetrag mit dem Prozentsatz multipliziert werden:<br><br>Übernachtfinanzierung Betrag = Geschäftsbetrag X Übernachtfinanzierung-Prozentsatz
                <br><br><br>
                <u><b><u>Beispiele</u></b></u><br><br>
                <b>Beispiel I</b><br><br>
                Dieses Beispiel zeigt eine Situation wo der Interbank-Zinssatz HÖHER als der Aufschlag ist. In diesem Fall wird Ihrem Konto ein Betrag belastet, wenn Sie Long Positionen öffnen und gutgeschrieben, wenn Sie Short Position öffnen:
                <br><br>
                <ul class="list-style-dashed mb-4">
                   <li>Handelsinstrument = Gazprom (GAZP)</li>
                   <li>Russischer Rubel (RUB) Zinssatz (annualisiert) = 9,5 % = 0,095</li>
                   <li>Aufschlag = 5% = 0.05</li>
                   <li>Geschäftsbetrag Wert in Währung = 2,459,000 RUB (20,000 Aktien zum aktuellen Schlusskurs von 122.95 RUB per share)</li>
                </ul>
      
                Übernachtfinanzierung-Prozentsatz bei Kauf (Long Position):<br><br>
                  
                  
                <div class="formula formula_f17 mb-2">
                    <div class="formula-name">Übernachtfinanzierung-Prozentsatz</div>
                    <div class="formula-equal" >=</div>
                    <div class="formula-f1">-
                        <div class="formula-sub">
                            <div class="formula-sub1">0.095 + 0.05</div>
                            <div class="formula-sub2">360</div>
                        </div>
                    </div>
                    <div class="formula-equal">=</div>
                    <div class="formula-f2">-0.0004</div>
                    <div class="formula-equal">=</div>
                    <div class="formula-f3">-0.04%</div>
                </div>

                Übernachtfinanzierung Betrag = 2,459,000 × (-0.0004) = -983.60 RUB, bedeutet 983.60 RUB Belastung pro Tag (≅17.52 USD)
                <br><br><br>
                Übernachtfinanzierung-Prozentsatz bei Verkauf (Short Position):<br><br>

                  <div class="formula formula_f18 mb-2">
                    <div class="formula-name">Übernachtfinanzierung-Prozentsatz</div>
                    <div class="formula-equal" >=</div>
                    <div class="formula-f1">
                        <div class="formula-sub">
                            <div class="formula-sub1">0.095 - 0.05</div>
                            <div class="formula-sub2">360</div>
                        </div>
                    </div>
                    <div class="formula-equal">=</div>
                    <div class="formula-f2">0.000125</div>
                    <div class="formula-equal">=</div>
                    <div class="formula-f3">0.0125%</div>
                </div>


                Übernachtfinanzierung Betrag = 2,459,000 × 0.000125 = 307.38 RUB credit per day (≅5.48 USD)
                <br><br><br>
                <b>Beispiel II</b><br><br>
                Dieses Beispiel zeigt eine Situation wo der Interbank-Zinssatz NIEDRIGER als der Aufschlag ist. In diesem Fall wird Ihrem Konto ein Betrag belastet, unabhängig davon auf welche Marktbewegung (long/short) Sie spekulieren:
                <br><br>
                <ul class="list-style-dashed mb-4">
                   <li>Handelsinstrument = Apple (AAPL)</li>
                   <li>US-Dollar (USD) Zinssatz (annualisiert) = 1,08 % = 0,0108</li>
                   <li>Aufschlag = 5% = 0.05</li>
                   <li>Geschäftsbetrag Wert in Währung = 70,600 USD (500 Aktien zum aktuellen Schlusskurs von 141.20 USD per share)</li>
                </ul>
         
                Übernachtfinanzierung-Prozentsatz bei Kauf (Long Position):<br><br>

                  <div class="formula formula_f19 mb-2">
                    <div class="formula-name">Übernachtfinanzierung-Prozentsatz</div>
                    <div class="formula-equal">=</div>
                    <div class="formula-f1">-
                        <div class="formula-sub">
                            <div class="formula-sub1">0.0108 + 0.05</div>
                            <div class="formula-sub2">360</div>
                        </div>
                    </div>
                    <div class="formula-equal">=</div>
                    <div class="formula-f2">-0.000169</div>
                    <div class="formula-equal">=</div>
                    <div class="formula-f3">-0.0169%</div>
                </div>
                  
                Übernachtfinanzierung Betrag = 70,600 × (-0.000169) = -11.93 USD, bedeutet 11.93 USD Belastung pro Tag
                <br><br><br>
                Übernachtfinanzierung-Prozentsatz bei Verkauf (Short Position):<br><br>
                  
                <div class="formula formula_f20 mb-2">
                    <div class="formula-name">Übernachtfinanzierung-Prozentsatz</div>
                    <div class="formula-equal">=</div>
                    <div class="formula-f1">
                        <div class="formula-sub">
                            <div class="formula-sub1">0.0108 - 0.05</div>
                            <div class="formula-sub2">360</div>
                        </div>
                    </div>
                    <div class="formula-equal">=</div>
                    <div class="formula-f2">-0.000109</div>
                    <div class="formula-equal">=</div>
                    <div class="formula-f3">-0.0109%</div>
                </div>
                Übernachtfinanzierung Betrag = 70,600 × (-0.000109) = -7.70 USD, bedeutet 7.70 USD Belastung pro Tag
              </p>`,
          data_id: "OvernightFinancing",
          content_after: `<p>* Die Abwicklung von Overnight-Finanzierungen kann bis zu 15 Minuten am Ende des Handelstages in Anspruch nehmen, woraufhin Ihrem Konto eine entsprechende Gutschrift oder Belastung gutgeschrieben wird.</p>`,
          table_titles: [
            "Instrument",
            "Täglicher Übernacht-Finanzierungssatz (Verkauf)",
            "Täglicher Übernacht-Finanzierungssatz (Kauf)",
            "Übernacht-Finanzierung (GMT)*",
          ],
          view_id: [ "Shares", "ETF"],
        },
        {
          //d: "dividends",
          id: "tc-view-7",
          title: "Dividenden",
          content_before: `<p>
                        Im Falle einer Ausschüttung von Bardividenden in Bezug auf eine CFD Aktie wird eine Dividendenanpassung auf den Saldo des Kunden vorgenommen, wobei die vom Kunden gehaltenen Positionen am Ende des Geschäftstages, der der Ex-Dividende vorausgeht, gegenübergestellt. Die Dividendenanpassung wird auf der Grundlage der Größe der Dividende, der Größe der Position des Kunden und ob es sich um eine Kauf- oder Verkaufstransaktion handelt, berechnet, wobei in den Long Positionen die Anpassung dem Saldo des Kunden gutgeschrieben und in den Short Positionen die Anpassung dem Saldo des Kunden abgezogen werden. Dividenden werden dem Saldo des Kunden außerhalb der Handelszeiten des Basiswerts und vor der Eröffnung des nächsten Handelstags der Aktie gutgeschrieben oder belastet und sind davon abhängig, dass der Kunde seine jeweilige Position zum Zeitpunkt der Dividendenanpassung hält. Um den Zeitwert des Eigenkapitals des Kunden während dieses Zeitraums bis zur Eröffnung des nächsten Handelstages zu erhalten, passt das Unternehmen die Position des Kunden entsprechend dem Dividendenbetrag an, der dem Saldo des Kunden belastet oder gutgeschrieben wurde.
                        <br><br>
                        <u>Beispiel:</u><br>
                        Coca-Cola gibt eine Dividende von 0,35 USD pro Aktie aus.<br>
                        Das Ex-Dividendendatum ist der 29. November und das Fälligkeitsdatum in iFOREX Europe ist der 28. November um 22:05 Uhr GMT.<br>
                        Der Schlusskurs vor der Fälligkeit beträgt 41,65.<br>
                        Einem Kunden, der eine Long Position von 5000 Aktien hält, werden mit 0,35 x 5000 = 1750 USD gutgeschrieben, wenn sein Deal am Erfüllungstag offen ist.
                        <br>
                        Ein ähnlicher Betrag belastet den Saldo eines Kunden, der eine Short Position besitzt.
                        <br>
                        Der Aktienkurs wird während der Nachlaufzeit von 41,65 auf 41,30 angepasst, was dem letzten Aktienkurs abzüglich der Dividende entspricht.
                      </p>`,
          data_id: "CorporateActions",
          content_after: "",
          no_information:"Derzeit sind keine Informationen über zukünftige Dividenden vorhanden.",
          table_titles: [
            "Aktie / ETF",
            "Markt",
            "Dividendenbetrag",
            "Datum und Uhrzeit (GMT)",
          ],
          view_id: "1",
        },
        {
          //id: "corporate_actions",
          id: "tc-view-1",
          title: "Aktiendividenden, Aktiensplits und andere Kapitalmaßnahmen",
          content_before: `<p>Kapitalmaßnahmen sind bestimmte Ereignisse, die sich auf den Aktienwert eines öffentlichen Unternehmens auswirken. Sofern im Folgenden in Bezug auf bestimmte Kapitalmaßnahmen nichts anderes erwähnt wird, wird iFOREX Europe bei Eintreten einer Kapitalmaßnahme in einer bestimmten Aktie alle offenen Positionen des/der betreffenden CFDs schließen, einschließlich, falls zutreffend, der Streichung aller Limit-Order(s) für diese CFD(s).
          <br><br>
          Kapitalmaßnahmen bei iFOREX Europe beinhalten, Bezugsrechtsangebote, Delisting sowie viele andere Ereignisse, die den Aktienkurs wesentlich beeinflussen können (einschließlich wesentliche Bekanntmachungen des Unternehmens, Übernahmen, Fusionen, Insolvenz etc.).
          <br><br>

          <b>Aktiendividenden</b><br>

            Aktiendividenden an der Börse verändern nicht den Gesamtwert der Aktien für diejenigen, die sie halten, sondern ändern die Anzahl der Aktien und deren Preis.<br>
            Sie erhalten den „Anpassungsfaktor“ für jede Aktie, die Sie halten.<br>
            Alle Ihre offenen Geschäfte und/oder Limit-Orders während des Datums und der Uhrzeit der Aktiendividende werden entsprechend hinsichtlich Menge, Preis und zugehöriger Limits angepasst (einschließlich des Kontostands aufgrund erforderlicher Gewinn-/Verlustanpassungen, falls zutreffend).<br>
            Zum Beispiel wird bei einer Aktienanpassung mit einem Anpassungsfaktor von 1,8 aus 1 Aktie nach dem Ereignis 1,8 Aktien, und der Preis wird durch 1,8 geteilt, sodass der Gesamtwert der Aktien unverändert bleibt.<br>
            Beispiel: 1 Aktie mit einem Preis von 1.000 $ wird nach dem Ereignis zu 1,8 Aktien mit einem Preis von 555,56 $: 1×1.000 $ = 1,8×555,56 $ = 1.000 $ Wert.<br><br>


          <strong>
          Besondere Regeln für Aktiensplits und Aktienzusammenlegungen (Reverse Stock Splits)
          </strong>
          <br>
          Aktiensplits und Aktienzusammenlegungen an der Börse verändern nicht den Gesamtwert der Aktien für diejenigen, die sie halten, sondern die Anzahl der Aktien und ihren Preis. Diese Splits werden in der Regel durchgeführt, wenn der Aktienkurs entweder zu hoch oder zu niedrig ist. Sollte ein offenes Geschäft/Limit von einem Aktiensplit betroffen sein, werden sein Betrag, sein Kurs und das Niveau des/der zugehörigen Limits entsprechend angepasst (einschließlich des Kontosaldos aufgrund der erforderlichen GV-Anpassungen, falls zutreffend).
          <br><br>
          Beispielsweise wird bei einem 1:10-Split aus 1 Aktie nach dem Ereignis 10 Aktien, und der Preis wird durch 10 geteilt, wobei der Gesamtwert der Aktien unverändert bleibt. So wird z. B. aus 1 Aktie mit einem Kurs von 1.000 $ nach dem Ereignis 10 Aktien mit einem Kurs von 100 $: 1x $1.000 = 10 x$100 = $1.000 Wert.
          <br><br>
          Nachfolgend finden Sie eine Liste mit den anstehenden Kapitalmaßnahmen:
              </p>`,
          data_id: "CorporateActions",
          content_after: "",
          no_information:"Derzeit stehen keine Informationen über künftigen Kapitalmaßnahmen zur Verfügung",
          table_titles: ["Aktie / ETF", "Markt", "Type", "Datum und Uhrzeit (GMT)"],
        },
        {
          //id: "earnings_reports",
          id: "tc-view-22",
          title: "Ergebnisberichte",
          content_before: `<p>
          Ein Gewinnbericht ist ein regelmäßiger Bericht, den börsennotierte Unternehmen abgeben, um über ihre Leistung zu berichten. Durch die Analyse der vierteljährlichen Gewinnberichte können die Anleger die finanzielle Gesundheit des Unternehmens analysieren. Die Bekanntgabe von Gewinnen für ein Unternehmen, insbesondere für ein beliebtes Unternehmen mit hoher Marktkapitalisierung, kann sich auf die Aktienkurse auswirken, was dazu führen kann, dass es an den Tagen der Veröffentlichung solcher Quartalsberichte stark schwankt.
          <br><br>
          Aus diesem Grund wird das maximale Engagement für die betreffenden Aktien während des gesamten Veröffentlichungszeitraums auf 10.000 $ gesenkt.
      </p>`,
          data_id: "",
          content_after: "",
        },
      ],
    },
  ];
  
  export { content };
  